export enum ReturnVerificationResult {
  Pending = "pending",
  Pass = "pass",
  Fail = "fail",
}
